var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    viewBox: "0 0 51 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5361 2.95115H37.4269V2.40984C37.4269 1.41744 36.5024 0.605469 35.3723 0.605469H9.48429C8.35426 0.605469 7.42969 1.41744 7.42969 2.40984V19.9122C7.42969 24.5134 11.6416 27.671 16.8809 27.671H27.9757C33.215 27.671 37.4269 24.5134 37.4269 19.9122V18.2883H41.5361C45.029 18.2883 50.2682 16.2133 50.2682 10.6197C50.2682 5.02617 45.029 2.95115 41.5361 2.95115ZM41.5361 13.7774H37.4269V7.46207H41.5361C42.1525 7.46207 45.1317 7.64251 45.1317 10.6197C45.1317 13.4165 42.5634 13.7774 41.5361 13.7774Z",
    fill: "#FCC800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0727 30.1992H1.8779C0.747866 30.1992 -0.176707 31.1014 0.0287539 32.0036C0.234214 33.2666 0.953326 34.9808 3.52158 35.7025C3.82977 35.7928 4.13796 35.7928 4.44615 35.7928C8.55536 35.7928 36.498 35.7928 40.6072 35.7928C40.9154 35.7928 41.2236 35.7928 41.5318 35.7025C44.1 34.9808 44.8191 33.3569 45.0246 32.0036C45.1273 31.0112 44.2028 30.1992 43.0727 30.1992Z",
    fill: "#FCC800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoffee);
export default __webpack_public_path__ + "static/media/icon_coffee.5c490a3391019f50e3cd838a4ff6df64.svg";
export { ForwardRef as ReactComponent };